import { useContext, useMemo } from 'react';
import CompareContext from '../components/RecordObject/RecordCompareContext';
import RecordCompareStateContext from '../RecordCompareStateContext';
function result(label) {
  var isEmpty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var uri = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var escape = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return {
    label: "".concat(label),
    // stringify numbers like day
    isEmpty: isEmpty,
    uri: uri,
    escape: escape
  };
}
function getLabel(_ref) {
  var property = _ref.property,
    record = _ref.record,
    schema = _ref.schema,
    uiSchema = _ref.uiSchema,
    definitions = _ref.definitions,
    fileMetadata = _ref.fileMetadata,
    singleLineOnly = _ref.singleLineOnly,
    cardView = _ref.cardView;
  var data = record.data,
    layout = record.layout;
  var widget = uiSchema[property] && uiSchema[property]['ui:widget'];
  var dataValue = data[property];
  var found = layout && layout.find(function (item) {
    return item.id === property;
  });
  if (!found) {
    return result('@dm/components.record-compare.labels.na', true);
  }
  if ((!dataValue || Array.isArray(dataValue) && dataValue.length === 0) && widget !== 'checkbox') {
    if (schema.properties[property].enumNames && schema.properties[property].enumNames.length === 2 && schema.properties[property].enumNames.indexOf('Yes') >= 0 && schema.properties[property].enumNames.indexOf('No') >= 0) {
      return result('@dm/components.record-compare.labels.none-selected', true);
    }
    if (cardView) {
      return result('@dm/components.record-compare.labels.empty-card-field', true);
    } else {
      return result('@dm/components.record-compare.labels.empty', true);
    }
  }
  var entry = schema.properties[property];
  if (!entry) {
    return result(dataValue);
  }
  if (widget === 'checkbox') {
    return result("@dm/components.record-compare.labels.".concat(dataValue ? 'true' : 'false'), true);
  }
  if (widget === 'file') {
    return result(fileMetadata.reduce(function (acc, entry) {
      return entry.uri === dataValue ? entry.fileName : acc;
    }, dataValue), false, dataValue);
  }
  if (widget === 'checkboxes') {
    var enumValues = entry.items.enum;
    var enumNames = entry.items.enumNames;
    var values = !enumNames ? enumValues : dataValue.map(function (val) {
      return enumNames[enumValues.indexOf(val)];
    });
    return result(values.join(singleLineOnly ? '; ' : '<br/>'), false, null, false);
  }
  if (widget === 'select' || widget === 'radio') {
    if (entry.enum && entry.enumNames) {
      var enumIndex = entry.enum && entry.enum.indexOf(dataValue);
      return result(entry.enumNames[enumIndex]);
    }
    if (entry.$ref) {
      var definition = definitions[entry.$ref];
      if (definition) {
        var _enumIndex = definition.enum && definition.enum.indexOf(dataValue);
        return result(definition.enumNames[_enumIndex]);
      }
    }
  }
  return result(dataValue);
}
export default function useRecordLabel(recordIndex, property) {
  var singleLineOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var _useContext = useContext(CompareContext),
    definitions = _useContext.definitions,
    fileMetadata = _useContext.fileMetadata,
    records = _useContext.records;
  var record = records[recordIndex];
  var schema = record.schema,
    uiSchema = record.uiSchema;
  var _useContext2 = useContext(RecordCompareStateContext),
    cardView = _useContext2.cardView;
  return useMemo(function () {
    return getLabel({
      definitions: definitions,
      fileMetadata: fileMetadata,
      property: property,
      record: record,
      schema: schema,
      singleLineOnly: singleLineOnly,
      uiSchema: uiSchema,
      cardView: cardView
    });
  }, [definitions, fileMetadata, property, record, schema, singleLineOnly, uiSchema]);
}